<template>
	<div class="progress-container">
		<div class="progress">
			<span
				class="progress-percent"
				:class="'classTextPercentage'"
				:style="stylePercentage"
				v-if="percentage < max"
			>{{percentage| formatNumber({maxDigits:digits})
			}}%</span>
			<span
				v-else
				class="done-process done-checked"
				:class="'classTextPercentage'"
				:style="stylePercentage"
			></span>
			<canvas :id="canvasId" :width="width" :height="height"></canvas>
		</div>
	</div>
</template>
<script>
import msBaseComponent from '@/components/msbase/msBaseComponent.vue';
export default {
	extends: msBaseComponent,
	name: 'msCircleBarProcess',
	props: {
		percentage: {
			default: 0,
			typeof: Number
		},
		posX: {
			default: 50,
			typeof: Number
		},
		posY: {
			default: 50,
			typeof: Number
		},
		width: {
			default: 50,
			typeof: Number
		},
		height: {
			default: 50,
			typeof: Number
		},
		colorProcess: {
			default: '#000000',
			typeof: String
		},
		lineWidth: {
			default: 8,
			typeof: Number
		},
		colorstrokeStyle: {
			default: '#E4E4E4',
			typeof: String
		},
		//Loại của đường viền trong process: "butt" - mặc định, "round" - bo tròn, hoặc "square" - hình chữ nhật
		lineCap: {
			default: 'round',
			typeof: String
		},
		canvasId: {
			default: 'canvas_bar',
			typeof: String
		},
		stylePercentage: {
			default: null,
			typeof: Object
		},
		max: {
			default: 100,
			typeof: Number
		},
		digits: {
			default : 0,
			typeof : Number
		}
	},
	data() {
		return {
			canvas: null,
			context: null,
			centerX: 0,
			centerY: 0,
			radius: 0
		};
	},
	created() {
		const me = this;
		// me.setupCircleBarProcess();
	},
	mounted() {
		const me = this;
		me.setupCircleBarProcess();
	},
	updated() {
		const me = this;
		me.setupCircleBarProcess();
	},
	computed: {},
	methods: {
		setupCircleBarProcess() {
			const me = this;
			me.canvas = document.getElementById(me.canvasId);
			me.context = me.canvas.getContext('2d');
			me.centerX = me.canvas.width / 2;
			me.centerY = me.canvas.height / 2;
			me.radius = me.canvas.width / 2 - 10;
			me.context.beginPath();
			me.context.arc(me.centerX, me.centerY, me.radius, 0, Math.PI * 2, false);
			me.context.lineCap = me.lineCap;
			me.context.lineWidth = me.lineWidth;
			me.context.strokeStyle = me.colorstrokeStyle;
			me.context.stroke();
			me.context.beginPath();
			me.context.arc(
				me.centerX,
				me.centerY,
				me.radius,
				-Math.PI / 2,
				(Math.PI * 2 * me.percentage) / 100 - Math.PI / 2,
				false
			);
			me.context.lineWidth = me.lineWidth;
			me.context.strokeStyle = me.colorProcess;
			me.context.stroke();
		}
	},
	watch: {}
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msCircleBarProcess.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msCircleBarProcess.scss';
}
.done-process {
	width: 20px;
    height: 20px;
}

.done-process::before {
	content: '';
    position: absolute;
    top: 28px;
    left: 27px;
    width: 4px;
    height: 12px;
    border-style: solid;
    border-color: $ms-color-primary;
    border-width: 0 4px 4px 0;
    transform: translateY(-50%) rotate(45deg);
    opacity: 0;
    transition: opacity .3s ease;
    border-radius: 2px;
}

.done-process.done-checked::before {
	opacity: 1;
}
</style>

